export default __webpack_public_path__ + "static/media/campminderIcon.449bff61.svg";